module.exports = __webpack_public_path__ + "static/photo_1-38a6f2a4dcdcec2f8e8a943fb906e9ff.jpg";